/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { QueryClient } from 'react-query';
import { useCreateTagMutation } from 'src/graphql';
import { TRootState } from 'src/store';

type CreateTagArgs = {
  tagTypeId: string;
  name: string;
  mutationAddTag: ReturnType<typeof useCreateTagMutation>['mutateAsync'];
  queryClient: QueryClient;
  setDuplicateTagName: (value: boolean) => void;
  setEmptyTagName: (value: boolean) => void;
};

export const createTagAction = createAsyncThunk<
  void,
  CreateTagArgs,
  { state: TRootState }
>(
  'tagType/tagCreated',

  async ({
    tagTypeId,
    name,
    mutationAddTag,
    queryClient,
    setDuplicateTagName,
    setEmptyTagName,
  }: CreateTagArgs) => {
    if (!name.trim()) {
      setEmptyTagName(true);
      return;
    }
    try {
      await mutationAddTag({
        parameters: {
          type: tagTypeId,
          name,
        },
      });

      queryClient.invalidateQueries('getOrganisationTagTypes');
      queryClient.invalidateQueries('getOrganisationTags');
    } catch (error) {
      if ((error as Error).message === 'Tag with this name already exists') {
        setDuplicateTagName(true);
      }
      throw error;
    }
  },
);
